"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Claudia Christ",
  role: "GRÜNDERIN & GESCHÄFTSFÜHRERIN",
  bio: "Mit über 20 Jahren Erfahrung als Diplom-Psychologin und Senior Coach, als Heilpraktikerin für Psychotherapie, sowie als Goldmedaillen-prämierte Tai Chi-Praktizierende und zertifizierte Yoga- und Achtsamkeitslehrerin leitet Claudia das Zentrum mit Herz und breit aufgestellter fachlicher Exzellenz.",
  image: {
    src: "https://excited-caiman.10web.cloud/wp-content/uploads/2026/05/20200713-SG7_9242-scaled.jpg?v=zu46uexrjc",
    srcset: "https://excited-caiman.10web.cloud/wp-content/uploads/2026/05/20200713-SG7_9242-scaled.jpg?v=51bjc6cdi25-wvc-srcset",
    sizes: "https://excited-caiman.10web.cloud/wp-content/uploads/2026/05/20200713-SG7_9242-scaled.jpg?v=p2nd27mw8fr-wvc-sizes",
    alt: "Portrait von Christine Christ"
  }
}, {
  name: "Christine Christ",
  role: "CO-GRÜNDERIN & CAMPUS-MANAGEMENT",
  bio: "Als Mitgründerin ist Christine das wirtschaftliche Rückgrat unseres Zentrums und lenkt mit jahrzehntelanger kaufmännischer Expertise die Finanzen und Liegenschaften. Gleichzeitig sorgt sie mit viel Empathie und Herzlichkeit für das persönliche Wohl unserer Teilnehmenden.\xA0",
  image: {
    src: "https://resilienz-zentrum-soonwald.de/wp-content/uploads/2026/05/IMG_20260523_110523-scaled.jpg?v=0kka4j5fzb2k",
    srcset: "https://excited-caiman.10web.cloud/wp-content/uploads/2026/05/IMG-20250529-WA0009.jpg?v=86e6xh6xnic-wvc-srcset",
    sizes: "https://excited-caiman.10web.cloud/wp-content/uploads/2026/05/IMG-20250529-WA0009.jpg?v=y8pnhfgglnm-wvc-sizes",
    alt: "Portrait von Dr. Marcus Weber"
  }
}];
export default function UnserFHrungsteam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261447" id="unser-führungsteam" className="relative bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 max-w-6xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {teamMembers.map((member, i) => <div key={i} data-index={i} className="flex flex-col items-center group">
              <div className="w-full max-w-[240px] aspect-[3/4] mb-4 overflow-hidden bg-muted rounded-2xl border border-primary/20 shadow-md transition-all duration-500 group-hover:shadow-lg">
                <img src={member.image.src} data-wvc-srcset={member.image.srcset} data-wvc-sizes={member.image.sizes} alt={member.image.alt} loading="lazy" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110" />
              </div>
              <div className="text-center">
                <h3 className="text-2xl font-serif text-primary mb-1">
                  {member.name}
                </h3>
                <p className="text-sm font-default font-semibold text-primary/70 uppercase tracking-wider mb-3">
                  {member.role}
                </p>
                <p className="text-muted-foreground font-default text-sm leading-relaxed px-4">
                  {member.bio}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-4 md:h-6 bg-primary/10" />
    </section>;
}